/**
 * Vocabularies stored as lookup tables, keyed by table name. Values are rows, not
 * Postgres enums, so adding a value is an insert.
 */
export enum Vocabulary {
  DependencyTypes = 'dependencyTypes',
  DirectiveVerbs = 'directiveVerbs',
  DocumentTypes = 'documentTypes',
  FileKinds = 'fileKinds',
  InstitutionKinds = 'institutionKinds',
  MarkingMethods = 'markingMethods',
  OutcomeAssociationTypes = 'outcomeAssociationTypes',
  QuestionRelationshipTypes = 'questionRelationshipTypes',
  QuestionTypes = 'questionTypes',
  RequirementRelations = 'requirementRelations',
  ResponseTypes = 'responseTypes',
  Scales = 'scales',
  SetTypeTags = 'setTypeTags',
  SolutionProvenance = 'solutionProvenance',
  SourceStyles = 'sourceStyles',
  Subjects = 'subjects',
  TopicGroupNodeTypes = 'topicGroupNodeTypes',
  TopicKinds = 'topicKinds',
  TopicMappingScopes = 'topicMappingScopes',
  TopicMigrationKinds = 'topicMigrationKinds',
}

/** A question type is a format, one per part, or a task, any number per part. */
export enum QuestionTypeFacet {
  Format = 'format',
  Task = 'task',
}

/** The formats, by code. A part with options is multiple choice. */
export enum QuestionFormat {
  MultipleChoice = 'multiple_choice',
  WrittenResponse = 'written_response',
}

/** How a scale is scored. Ordinal and count scales take whole numbers only. */
export enum ScaleKind {
  Ordinal = 'ordinal',
  Continuous = 'continuous',
  Count = 'count',
}

/** `document_types.code` values from the reference data. */
export enum DocumentType {
  Questions = 'questions',
  Solutions = 'solutions',
  Combined = 'combined',
  Unknown = 'unknown',
}

/** `source_styles.code` values from the reference data. */
export enum SourceStyle {
  HscExam = 'hsc_exam',
  TrialExam = 'trial_exam',
  SchoolAssessment = 'school_assessment',
  Textbook = 'textbook',
  Workbook = 'workbook',
  QuestionBank = 'question_bank',
  InternallyAuthored = 'internally_authored',
  Other = 'other',
  Unknown = 'unknown',
}

/** `solution_provenance.code` values from the reference data. */
export enum SolutionProvenance {
  ReadFromSource = 'read_from_source',
  ReadFromHandwriting = 'read_from_handwriting',
  HumanAuthored = 'human_authored',
  Generated = 'generated',
}

/** `response_types.code` values from the reference data. */
export enum ResponseType {
  TypedLatex = 'typed_latex',
  McqSelection = 'mcq_selection',
  FileUpload = 'file_upload',
}

/** `marking_methods.code` values from the reference data. */
export enum MarkingMethod {
  Manual = 'manual',
  Automatic = 'automatic',
}

/** `dependency_types.code` values from the reference data. */
export enum DependencyType {
  Requires = 'requires',
  ReferencesAnswer = 'references_answer',
}
